import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from '../../../config/appConfig';
import Utils from '../../../utils/Utils';
import settings from "../../../devices/all/settings";

class LoginCMByPhoneTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();

        this.body = {msisdn: params.phoneNumber, code: params.code}
    }

    getHeaders() {
        const headerParams = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return headerParams;
    }

    getUrl() {
        const config = getAppConfig();
        let url = `${config.end_point_music}/middleware/user/loginByPhone?`;
            url += this.getQueryStringParams();

        // url ya contiene el http/https
        return url;
    }

    getParams() {
        return Utils.encodeParams(this.body);
    }

    getQueryStringParams() {
        let params = super.getParams();
        params.tenant_code = settings.tenant_code;
        params.version = '1.0.0';
        params = Object.assign({}, params, this.queryParams);
        return Utils.buildQueryParams(params);
    }

    isValid(data) {
        if (!data.response) {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }

    getMethod() {
        return 'POST';
    }

    getEncType() {
        return "application/x-www-form-urlencoded";
    }

    getShowErrorModal(){
      return false;
    }
}

export default LoginCMByPhoneTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/music/LoginCMByPhoneTask.js